import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import { FieldViewType } from "../viewType";
import fieldsDictionary from "../fieldsDictionary";
import PhoneFieldEdit from "./edit";
import PhoneFieldDetail from "./detail";
import PhoneFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type phone en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Phone() {
    return _jsx(_Fragment, { children: "Phone" });
}
var field = fieldsType.phone;
fieldsDictionary.registerField(FieldViewType.EDIT, field, PhoneFieldEdit);
fieldsDictionary.registerField(FieldViewType.DETAIL, field, PhoneFieldDetail);
fieldsDictionary.registerField(FieldViewType.LIST, field, PhoneFieldList);
